<template>
  <main>
    <ServicesSection />
    <PhotoCarousel />
  </main>
</template>

<script>
import ServicesSection from '../components/ServicesSection.vue'
import PhotoCarousel from '../components/PhotoCarousel.vue'

export default {
  name: 'ServicesPage',
  components: {
    ServicesSection,
    PhotoCarousel
  }
}
</script>
